import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
// eslint-disable-next-line
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";
// eslint-disable-next-line
import { fade, Grid, Icon, List, ListItem, ListItemText, ListItemIcon, Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
// eslint-disable-next-line
import Divider from "@material-ui/core/Divider";

const AccessibilityTooltip = React.lazy(() => import("../../components/_common/AccessibilityTooltip"));

const useStyles = makeStyles((theme) => ({
    AccordionRoot: {
        // border: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        boxShadow: "none",
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    AccordionRootExpanded: {
        "& > div:first-child": {
            backgroundColor: fade(theme.palette.primary.main, 0.0675),
        },
    },
    AccordionSummaryRoot: {
        // backgroundColor: fade(theme.palette.primary.main, 0.0675),
        // borderBottom: `1px solid ${fade(theme.palette.primary.main, 0.125)}`,
        marginBottom: -1,
        minHeight: "32px!important",
        "&.$expanded": {
            minHeight: 32,
        },
    },
    AccordionSummaryContent: {
        margin: `${theme.spacing(1, 0)}!important`,
    },
    AccordionSummaryContentExpanded: {
        // margin: theme.spacing(0, 0),
        // backgroundColor: fade(theme.palette.primary.main, 0.0675),
    },
    AccordionSummaryTitle: {
        fontSize: "1rem", //'0.875rem',
        fontWeight: 400, //theme.typography.fontWeightMedium
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.875rem",
        },
    },
    AccordionDetailsRoot: {
        padding: theme.spacing(2),
    },
    card: {
        height: "100%",
    },
    cardHeaderRoot: {
        backgroundColor: fade(theme.palette.primary.main, 0.00675),
        padding: theme.spacing(1, 1, 0, 2),
    },
    cardContent: {
        padding: theme.spacing(0, 1, 2, 2),
    },
    cardHeaderTitle: {
        fontSize: "0.8rem",
        fontWeight: theme.typography.fontWeightMedium,
    },
    expanded: {},
    listItemTextPrimary: {
        fontSize: "0.875rem",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
        },
    },
    listItemTextSecondary: {
        fontSize: "0.875rem",
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.75rem",
        },
    },
}));

const GestorzyAccordion = ({ gestor, data, checked, onChecked, report }) => {
    // eslint-disable-next-line
    const { t } = useTranslation();
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState("panel1");

    const handleChange = (panel) => (event, newExpanded) => {
        // console.log(event.target)
        // console.log(data, gestor)
        if (event.target.hasAttribute("data-preventactions")) return;
        setExpanded(newExpanded ? panel : false);
    };

    const handleToggle = (value) => {
        onChecked(value);
    };

    // console.log(
    //     checked.filter(c => c.gestor_id === gestor.id).length,
    //     data.length,
    //     !!(checked.filter(c => c.gestor_id === gestor.id).length &&
    //     checked.filter(c => c.gestor_id === gestor.id).length < data.length)
    // )

    return (
        <div>
            {/* <pre>{JSON.stringify(data, null,4)}</pre> */}
            <Accordion
                square
                expanded={expanded === `obiekt-${gestor.id}`}
                onChange={handleChange(`obiekt-${gestor.id}`)}
                classes={{ root: classes.AccordionRoot, expanded: classes.AccordionRootExpanded }}
            >
                <AccordionSummary
                    aria-controls={`obiekt-${gestor.id}-content`}
                    id={`obiekt-${gestor.id}-header`}
                    expandIcon={<Icon>keyboard_arrow_down</Icon>}
                    classes={{ root: classes.AccordionSummaryRoot, content: classes.AccordionSummaryContent }}
                >
                    <ListItem>
                        {report && (
                            <ListItemIcon>
                                <AccessibilityTooltip arrow={false} placement="bottom" title={`Dodaj do raportu`}>
                                    <Checkbox
                                        edge="start"
                                        checked={
                                            !!(
                                                checked.filter((c) => c.gestor_id === gestor.id).length &&
                                                checked.filter((c) => c.gestor_id === gestor.id).length === data.length
                                            )
                                        }
                                        tabIndex={-1}
                                        disableRipple
                                        // inputProps={{ 'aria-labelledby': item.id_systemu }}
                                        inputProps={{
                                            "data-preventactions": true,
                                        }}
                                        indeterminate={
                                            !!(
                                                checked.filter((c) => c.gestor_id === gestor.id).length &&
                                                checked.filter((c) => c.gestor_id === gestor.id).length < data.length
                                            )
                                        }
                                        color={"primary"}
                                        onChange={() => handleToggle(data)}
                                    />
                                </AccessibilityTooltip>
                            </ListItemIcon>
                        )}
                        <ListItemText
                            primary={
                                <Typography className={classes.AccordionSummaryTitle}>
                                    {gestor.title}
                                    <small>({data.length})</small>:
                                </Typography>
                            }
                        />
                    </ListItem>
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.AccordionDetailsRoot }}>
                    <Grid container spacing={1}>
                        {data.map((item, key) => {
                            return (
                                <Grid item xs={12} md={12} key={key}>
                                    <ListItem
                                        // selected={selected === item.id_systemu.toString()}
                                        dense={true}
                                        className={classes.listItemLI}
                                        classes={{ selected: classes.listItemSelected }}
                                        key={key}
                                        id={`item-${item.id_systemu}`}
                                    >
                                        {report && (
                                            <ListItemIcon>
                                                <AccessibilityTooltip
                                                    arrow={false}
                                                    placement="bottom"
                                                    title={
                                                        checked.find((c) => c.id_systemu === item.id_systemu)
                                                            ? `Usuń z rapotu`
                                                            : `Dodaj do raportu`
                                                    }
                                                >
                                                    <Checkbox
                                                        edge="start"
                                                        checked={
                                                            !!checked.find((c) => c.id_systemu === item.id_systemu)
                                                        }
                                                        tabIndex={-1}
                                                        disableRipple
                                                        inputProps={{ "aria-labelledby": item.id_systemu }}
                                                        color={"primary"}
                                                        onChange={() => handleToggle(item)}
                                                    />
                                                </AccessibilityTooltip>
                                            </ListItemIcon>
                                        )}
                                        <ListItemText
                                            primary={
                                                <a
                                                    //Uncomment next if change this <span> to <a>
                                                    // href={item.link}
                                                    // href={`/#/rsigestorzy/${item.id_systemu}`}
                                                    href={`/#/rsisystemy/${item.id_systemu}`}
                                                    // target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: "inherit", textDecoration: "inherit" }}
                                                >
                                                    {item.nazwa_systemu}
                                                </a>
                                            }
                                            secondary={`${
                                                item.nazwa_systemu_skr ? item.nazwa_systemu_skr + ", " : ""
                                            } ${item.gestor}`}
                                            classes={{
                                                primary: classes.listItemTextPrimary,
                                                secondary: classes.listItemTextSecondary,
                                            }}
                                        />
                                    </ListItem>
                                </Grid>
                            );
                        })}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export default GestorzyAccordion;
